import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Buying by advertised price</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    { url: '/ways-to-purchase', name: 'Ways to purchase' },
                    {
                      url: '/ways-to-purchase/advertised-price',
                      name: 'Advertised Price',
                    },
                  ]}
                />
                <h2 className="lead text-center">Advertised Price</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    ​
                    <p>
                      In this method a property is advertised at a set price and offers are presented at or around that
                      number. Selling by advertised price is increasingly rare these days, most often used for the
                      higher-priced properties on the market. If you see a property that ticks all your boxes and is
                      advertised at a set price that you are prepared to pay, then this can be much simpler than some
                      other purchase methods as you know exactly what you can get the house for.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ways_to_purchase/AdvertisedPrice.jsx